import { ContactFormData } from "./ContactForm";
import { Intention } from "./ContactFormHandler";

export function sendContactFormData(data: ContactFormData, intention: Intention): Promise<boolean> {
    return fetch(`/api/contact?intention=${intention}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(response => response.ok);
}